import { Building2 } from "lucide-react";

/**
 * Shared loading fallback used across the app shell and marketing routes.
 *
 * Having ONE loader eliminates the double-fallback flicker that happened when
 * App.tsx rendered `ShellFallback` → MarketingApp rendered `MarketingFallback` →
 * Landing rendered its own skeleton. The visual switch between two distinct
 * spinners/pulses was the root cause of the landing-page flicker.
 */
export function PageLoader() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-slate-50">
      <div className="flex items-center gap-2">
        <Building2 className="w-5 h-5 text-indigo-600" aria-hidden="true" />
        <span className="text-xs font-bold uppercase tracking-widest text-slate-600">
          Loading RealtyIQ.io...
        </span>
      </div>
    </div>
  );
}